import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
}), 'CropDinTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropDinTwoTone.js
// module id = 3008
// module chunks = 2